import { createContext, useContext } from 'react';
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

const MaintenanceContext = createContext();

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenance must be used within a MaintenanceProvider');
  }
  return context;
};

export const MaintenanceProvider = ({ children }) => {
  // Use the imported MAINTENANCE_MODE variable directly
  const isMaintenanceMode = MAINTENANCE_MODE;

  const value = {
    isMaintenanceMode,
    setIsMaintenanceMode: () => {
      // Maintenance mode is controlled by MAINTENANCE_MODE in Urls.js
    }
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};
